import { withRouter } from 'next/router';
import { useEffect, useRef } from 'react';
import URI from 'urijs';
type Props = {
  onChange: (value: any) => any;
  queryKey: string;
  router: any;
};

function _WatchLocationQueryChange({ queryKey, onChange, router }: Props) {
  const prevRouterRef = useRef(router);

  useEffect(() => {
    if (router.query[queryKey]) {
      onChange(router.query[queryKey]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const prevRouter = prevRouterRef.current;
    const previousPathname = new URI(prevRouter.asPath).pathname();
    const pathname = new URI(router.asPath).pathname();

    if (prevRouter.query[queryKey] !== router.query[queryKey] && previousPathname === pathname) {
      onChange(router.query[queryKey]);
    }
    prevRouterRef.current = router;
  }, [router, queryKey, onChange]);

  return null;
}

export const WatchLocationQueryChange = withRouter(_WatchLocationQueryChange);
